import { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  LinearProgress,
} from "@material-ui/core";

import { Close as CloseIcon } from "@material-ui/icons";

import Api from "lib/api/httpRequestHelper";
import ImagePlaceholder from "components/Image/ImagePlaceholder";
import CarouselShowCase from "./showcase";
import { IsMobile } from "utils/is-mobile";

export function DialogProductDetailShowcaseClient({
  detail,
  open,
  handleClose,
  storeId,
}) {
  const isMobile = IsMobile();

  const [productGrid, setProductGrid] = useState([]);
  const [productSelected, setProductSelected] = useState([]);
  const [productImage, setProductImage] = useState(null);
  const [searching, setSearching] = useState(false);
  const [productMidia, setProductMidia] = useState(null);

  const handleGetProductDetails = async (sizeSelected) => {
    await Api.get(
      "product-details",
      "product",
      `?idProduto=${sizeSelected?.IdProduto}&idPessoaLoja=${storeId}`,
      true
    )
      .then(({ Result }) => {
        setProductMidia(Result?.Midias);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleSelectProduct = (selected) => {
    setProductSelected(selected);
    setProductImage(selected?.UrlProduto);
    handleGetProductDetails(selected);
  };

  const handleGetProductGrid = async () => {
    setProductGrid([]);
    setSearching(true);

    await Api.get(
      "product-grid",
      "product",
      "?IdProduto=" + detail?.idProduto?.toString(),
      true
    )
      .then(({ Result }) => {
        setProductGrid(Result?.ListaCores);
        if (Result?.ListaCores?.length === 1) {
          handleSelectProduct(Result?.ListaCores[0]);
        }
      })
      .catch((error) => {
        console.log(error);      })
      .finally(() => setSearching(false));
  };

  useEffect(() => {
    if (productGrid?.length !== 1 && productGrid?.length !== 0) {
      handleSelectProduct(productGrid[0]);
    }
  }, [productGrid]);

  useEffect(() => {
    if (detail) {
      if (productImage === null) {
        setProductImage(detail?.fotos[0]);
      }
      handleGetProductGrid();
    }
  }, [detail]);

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        <Grid
          item
          xs={12}
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginBottom: "-1rem",
          }}
        >
          <IconButton aria-label="close" onClick={handleClose}>
            <Box
              component={CloseIcon}
              width="1.25rem!important"
              height="1.25rem!important"
            />
          </IconButton>
        </Grid>
        <Typography variant="h3" component="h3">
          Detalhes do produto
        </Typography>
      </DialogTitle>
      <DialogContent
        style={{
          padding: "0 1.5rem 1.5rem",
        }}
      >
        <div
          role="presentation"
          style={{
            display: "flex",
            justifyItems: "center",
            flexDirection: "column",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              height: "12rem",
            }}
          >
            {productMidia !== null ? (
              <CarouselShowCase isMobile={isMobile} items={productMidia} />
            ) : (
              <ImagePlaceholder
                alt="Imagem do item do produto"
                src={productImage}
                width={isMobile ? 180 : 200}
                widthOnError={isMobile ? 180 : 200}
                imagePreviewTitle={`Produto`}
              />
            )}
          </div>

          <div
            role="presentation"
            style={{
              display: "flex",
              flexDirection: "column",
              marginLeft: isMobile ? "0.5rem" : "0.25rem",
              marginTop: isMobile ? "1rem" : 0,
            }}
          >
            <Typography
              id="alert-dialog-description"
              variant="h5"
              style={{ fontSize: isMobile ? "0.7rem" : "0.85rem" }}
            >
              {detail.descricao}
            </Typography>

            {searching ? (
              <div>
                <span>Buscando detalhes do produto...</span>
                <LinearProgress />
              </div>
            ) : (
              <>
                {productGrid?.length !== 0 && (
                  <>
                    <Typography
                      variant="h4"
                      component="h4"
                      style={{
                        marginTop: "1.3rem",
                        marginBottom: "1rem",
                        fontSize: isMobile ? "0.7rem" : "0.85rem",
                      }}
                    >
                      {productGrid?.length !== 1
                        ? "Cores disponíveis"
                        : "Cor disponível"}
                    </Typography>
                    <div
                      style={{
                        display: isMobile ? "grid" : "flex",
                        gridGap: isMobile ? "15px" : 0,
                        gridTemplateColumns: isMobile
                          ? "repeat(auto-fill, minmax(3.8rem, 1fr))"
                          : 0,
                        justifyContent: "flex-start",
                      }}
                    >
                      {productGrid?.map((product) => {
                        return (
                          <div
                            key={product?.IdProduto}
                            style={{
                              width:
                                product?.Cor?.length > 9
                                  ? isMobile
                                    ? "5rem"
                                    : "5.5rem"
                                  : isMobile
                                  ? "3.8rem"
                                  : "4.2rem",
                              marginRight: isMobile ? 10 : 15,
                              padding: isMobile
                                ? "0.25rem 0.2rem"
                                : "0.25rem 0.15rem",
                              borderRadius: "0.25rem",
                              border:
                                productSelected?.IdProduto ===
                                product?.IdProduto
                                  ? "3px solid #2C475C"
                                  : "1px solid #2C475C",
                              color: "#2C475C",
                              cursor: "pointer",
                              fontWeight: "bold",
                              fontSize: isMobile ? "0.7rem" : "0.8rem",
                              textAlign: "center",
                            }}
                            onClick={() => handleSelectProduct(product)}
                          >
                            {product?.Cor?.toUpperCase()}
                          </div>
                        );
                      })}
                    </div>
                  </>
                )}

                {productSelected?.length !== 0 &&
                  productSelected?.ListaTamanhos?.length !== 0 && (
                    <>
                      <Typography
                        variant="h4"
                        component="h4"
                        style={{
                          marginTop: "1.3rem",
                          marginBottom: "1rem",
                          fontSize: isMobile ? "0.7rem" : "0.85rem",
                        }}
                      >
                        {productSelected?.ListaTamanhos?.length !== 1
                          ? "Tamanhos disponíveis"
                          : "Tamanho disponível"}
                      </Typography>
                      <div
                        style={{
                          display: isMobile ? "grid" : "flex",
                          gridGap: isMobile ? "15px" : 0,
                          gridTemplateColumns: isMobile
                            ? "repeat(auto-fill, minmax(3.8rem, 1fr))"
                            : 0,
                          justifyContent: "flex-start",
                        }}
                      >
                        {productSelected?.ListaTamanhos?.map((size) => {
                          return (
                            <div
                              key={size?.IdProduto}
                              style={{
                                width:
                                  size?.Tamanho?.length > 9
                                    ? isMobile
                                      ? "5rem"
                                      : "5.5rem"
                                    : isMobile
                                    ? "3.8rem"
                                    : "4.2rem",
                                marginRight: isMobile ? 10 : 15,
                                padding: isMobile
                                  ? "0.25rem 0.2rem"
                                  : "0.25rem 0.15rem",
                                borderRadius: "0.25rem",
                                border: "1px solid #2C475C",
                                fontWeight: "bold",
                                fontSize: isMobile ? "0.7rem" : "0.8rem",
                                textAlign: "center",
                                color: "#2C475C",
                              }}
                            >
                              {size?.Tamanho?.toUpperCase()}
                            </div>
                          );
                        })}
                      </div>
                    </>
                  )}
              </>
            )}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
